document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action="/search"]').forEach(form => {
    form.addEventListener('submit', () => {
      const visibleInput = form.querySelector('input[name="q"]');
      if (!visibleInput) return;

      const rawValue = visibleInput.value.trim();
      if (!rawValue) return;

      let hiddenInput = form.querySelector('input[name="q"][type="hidden"]');

      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'q';
        form.appendChild(hiddenInput);
      }

      hiddenInput.value = rawValue.startsWith('title:')
        ? rawValue
        : `title:${rawValue}`;

      visibleInput.name = '_q';
    });
  });
});
